// Share / revoke the public link for one trip group.
//
// A thin wrapper over ShareLinkModal, which owns the five-state machine this
// used to hold. The machine is shared with the logbook-trip version because it
// IS the rules -- re-query on every open, at most one row per key, revoke =
// delete the row -- and everything below is what this dialog is about.

import { useCallback } from 'react';
import ShareLinkModal from './ShareLinkModal';
import {
  createTripShare,
  getTripShareForGroup,
  deleteTripShare,
} from '../../utilities/Database.mjs';
import { fullUrlForSharedTrip } from '../../fleet-shared/Urls.mjs';

const DESCRIPTION = `Anyone with the link can view this trip's itinerary and map — no
        account needed. The link always shows the trip as it currently is, and
        you can revoke it here at any time.`;

const ACTIVE_NOTE =
  "The link shows the trip's current state, including edits made after sharing.";

export default function ShareTripModal({ show, onHide, itemId, groupKey, groupName }) {
  const load = useCallback(
    () => getTripShareForGroup(itemId, groupKey),
    [itemId, groupKey]
  );
  const create = useCallback(
    () => createTripShare(itemId, groupKey),
    [itemId, groupKey]
  );
  const revoke = useCallback((share) => deleteTripShare(share.id), []);
  const urlFor = useCallback((share) => fullUrlForSharedTrip(share.id), []);

  return (
    <ShareLinkModal
      show={show}
      onHide={onHide}
      title={`Share ${groupName || 'Trip'}`}
      description={DESCRIPTION}
      activeNote={ACTIVE_NOTE}
      load={load}
      create={create}
      revoke={revoke}
      urlFor={urlFor}
    />
  );
}
